<template>
  <div>
    <vxe-toolbar
      id="toolbarId_re43"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('verificationReview_search_button')"
          @click="funcFilter"
          >查询</el-button
        >
        <el-button
          v-if="getLimit('verificationReview_export_button')"
          @click="funcExport"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-hover-row
      highlight-current-row
      row-id="id"
      height="700"
      :loading="loading"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="实际承运人姓名"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="联系电话"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入联系电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="identificationNumber"
          title="身份证号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.identificationNumber"
            placeholder="请输入身份证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="licenseIssuingAgencies"
          title="身份证发证机关"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseIssuingAgencies"
            placeholder="请输入身份证发证机关"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="issuingDate"
          title="身份证有效期起"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.issuingDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            @change="value => changeDate(value, 'issuingDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="idCardDueDate"
          title="身份证有效期止"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.idCardDueDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            @change="value => changeDate(value, 'idCardDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverType"
          :formatter="formatterDriverType"
          title="实际承运人类型"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.driverType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in driverTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="verifyAddr"
          :formatter="formatterverifyAddr"
          title="公安比对状态"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.verifyAddr"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in gaOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="verifyType"
          :formatter="formatterverifyType"
          title="认证通过方式"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.verifyType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in rzOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="verifyFlag"
          :formatter="formatterverifyFlag"
          title="认证状态"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.verifyFlag"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="verifyRemark"
          title="人工审核备注"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.verifyRemark"
            placeholder="请输入人工审核备注"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="verifyTime"
          title="核验时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.verifyTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'verifyTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入最后操作人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="280" fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="详情" placement="top">
            <vxe-button type="text" @click="funcDetail(scope.row.code)"
              ><i class="el-icon-document"
            /></vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.verifyAddr == 2 && scope.row.verifyFlag != 1"
            class="item"
            effect="dark"
            content="审核"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcReview(scope.row.code, scope.row.partyCode)"
              ><i class="el-icon-s-check"
            /></vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <!-- 审核 -->
    <vxe-modal
      v-model="reviewFlag"
      title="审核"
      width="1200"
      height="800"
      resize
    >
      <driverReview
        ref="reviewRef"
        :parent-data="parentData"
        @fatherMethods="fatherMethods"
      />
    </vxe-modal>
    <vxe-modal
      v-model="driverFlag"
      title="详情"
      width="1200"
      height="800"
      resize
    >
      <driverDetail
        ref="detailRef"
        :parent-data="parentData"
        @fatherMethods="fatherMethods"
      />
    </vxe-modal>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import driverReview from "./components/driverReview.vue";
import driverDetail from "./components/driverDetail.vue";
import { taxAuthList } from "@/api/driver";

export default {
  name: "CarrierReview",
  components: {
    driverReview,
    driverDetail
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/driver/exportTaxAuthList", //导出接口
        name: "核验审核"
      },
      parentData: {
        isDetail: true,
        areaOptions: [],
        vehicleTypeAllowList: [],
        vehicleClassificationList: [],
        vehicleLengthList: [],
        vehicleWidthList: [],
        vehicleHighList: [],
        vehicleTonnageList: [],
        locationSourceList: [],
        vehicleLicenseColorList: [],
        vehicleEnergyTypeList: [],
        receiverUserCodeOptions: [],
        typeOptions: [],
        bankOptions: []
      },
      isCtms: true, //默认显示  同城系统隐藏
      loading: false,
      tableData: [],
      driverFlag: false,
      reviewFlag: false,
      datagramFlag: false,
      groupLevel: 0,
      listQuery: {
        issuingDateRange: [],
        idCardDueDateRange: [],
        verifyTimeRange: [],
        gmtCreatedRange: [],
        authTimeRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      sumObject: {
        balance: 0
      },
      // 审核状态
      rzOptions: [
        {
          label: "公安接口",
          value: 1
        },
        {
          label: "人工审核",
          value: 2
        }
      ],
      // 实际承运人/车队类型
      gaOptions: [
        {
          label: "未认证",
          value: 0
        },
        {
          label: "通过",
          value: 1
        },
        {
          label: "失败",
          value: 2
        }
      ],
      //
      statusOptions: [
        {
          label: "未认证",
          value: 0
        },
        {
          label: "已认证",
          value: 1
        },
        {
          label: "未通过",
          value: 2
        }
      ],
      // 实际承运人/车队类型
      driverTypeOptions: [
        {
          label: "独立实际承运人",
          value: 0
        },
        {
          label: "车队",
          value: 1
        },
        {
          label: "车队实际承运人",
          value: 2
        }
      ],
      loginkTarget: 0,
      vehicleClassificationList: [],
      vehicleTonnageList: []
    };
  },
  watch: {
    $route(to, from) {
      const v = to.query.todo;
      if (v) {
        this.listQuery.authStatusExt = 0;
      } else {
        this.listQuery.authStatusExt = "";
      }
      this.findList();
    }
  },
  created() {
    this.findList();
  },
  methods: {
    // 类型筛选
    formatterDriverType({ cellValue }) {
      let item = this.driverTypeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 类型筛选
    formatterverifyAddr({ cellValue }) {
      let item = this.gaOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterverifyFlag({ cellValue }) {
      let item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterverifyType({ cellValue }) {
      let item = this.rzOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        taxAuthList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 审核
    funcReview(code, partyCode) {
      this.reviewFlag = true;
      this.$nextTick(function() {
        this.$refs.reviewRef.getDriver(code, partyCode);
      });
    },
    // 详情方法
    funcDetail(code) {
      this.driverFlag = true;
      this.$nextTick(function() {
        this.$refs.detailRef.getDriver(code);
      });
    },
    fatherMethods() {
      this.reviewFlag = !this.reviewFlag;
      this.findList();
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "balance") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    },
    checCheckboxkMethod2({ row }) {
      return row.isSendLoginkExt != 1;
    },
    // 翻译车型
    formatterVehicleClassification({ cellValue }) {
      const item = this.vehicleClassificationList.find(
        item => item.code === cellValue
      );
      return item ? item.name : "";
    }
  }
};
</script>
